export const BULK_CALL_TIMEOUT = 500;
